module.exports = __webpack_public_path__ + "89a551c6063042ace50024e3e4ca9783.m4a";


//////////////////
// WEBPACK FOOTER
// ./src/components/InteractiveExample/de/3.m4a
// module id = 972
// module chunks = 4